import React, { useContext, useState, useEffect, useMemo } from "react";
import { CurrentUserContext } from "../../context/CurrentUserContext";
import { useTranslation } from "../../utils/hooks/translateHook";
import { useNavigate } from "react-router-dom";
import Packages from "../Content/Packages/Packages";
import "./MyCourses.css";
import PackagesIcon from "../../images/icons/PackegesIcon.svg";
import HTML from "../../images/courses/arrow.png";
import PYTHON from "../../images/courses/Rocket.png";
import JAVASCRIPT from "../../images/courses/Pink Computer.png";
import SEO from "../../images/courses/Violet computer.png";
import SMM from "../../images/courses/media.png";
import FUNDAMENTALS from "../../images/courses/Trading.png";
import { BASE_URL } from "../../utils/API/MainApi";
import { getCourseProgress } from "../../utils/API/progressApi.js";
import homeVideo from "../../images/homevideo.mp4";
import arrow from "../../images/icons/ArrowOrange.svg";

function MyCourses() {
  const { currentUser } = useContext(CurrentUserContext);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const t = useTranslation();
  
  const coursesData = [
    { slug: "fundamentals", title: "Fundamentals", img: FUNDAMENTALS},
    { slug: "html", title: "HTML & CSS", img: HTML}, 
    { slug: "python", title: "Python", img: PYTHON},
    { slug: "javascript", title: "JavaScript", img: JAVASCRIPT },
    { slug: "seo", title: "SEO", img: SEO },
    { slug: "smm", title: "Social Media", img: SMM}
  ];

  const userCourses = useMemo(() => {
    return new Map(
      (currentUser?.courses || []).map(course => [
        course.courseSlug, course])
    );
  }, [currentUser]);

  useEffect(() => {
    if (!selectedCourse && currentUser?.courses?.length > 0) {
      setSelectedCourse(currentUser.courses[0].courseSlug);
    }
  }, [currentUser, selectedCourse]);

  useEffect(() => { //for change user so that selectedCourse will be change 
    if (currentUser?.courses?.length > 0) {
      setSelectedCourse(prev =>
        prev && userCourses.has(prev) ? prev : currentUser.courses[0].courseSlug);}
  }, [currentUser, userCourses]);


  return (
    <div className="mycourses-container">
      <div className="mycourses-header video-header">
        <video autoPlay muted loop className="bg-video">
          <source src={homeVideo} type="video/mp4" />
        </video>
        <div className="header-overlay" />
         <h1> {t("hello").toUpperCase()} {currentUser?.name.toUpperCase() || t("user")},</h1>
        <div className="ready-card">
          <span> {t("R_U_ready").toUpperCase()}</span>
        </div>
      </div>

      <div className="courses-row">
        <div className="mycourses-headline"> <p>{t("yourCourses").toUpperCase()}</p> </div>
        {coursesData.map(course => {
          const userCourse = userCourses.get(course.slug);
          const purchased = !!userCourse;

          return (
            <CourseCard
              key={course.slug}
              course={course}
              purchased={purchased}
              level={userCourse?.level}
              selected={selectedCourse === course.slug}
              onClick={() => purchased && setSelectedCourse(course.slug)}
            />
          );
        })}
      </div>
      {selectedCourse && (
        <CourseDetails
          courseSlug={selectedCourse}
          coursesData={coursesData}
          currentUser={currentUser}
          userCourses={userCourses}
        />
      )}
    </div>
  );
}

export default MyCourses;



function CourseCard({ course, purchased, level, selected, onClick }) {
  const navigate = useNavigate();
  return (
    <div className={`course-card ${purchased ? "active" : "locked"} ${selected ? "active-course" : ""}`}
      onClick={onClick}
    >
      <div className="card-image">
        <img src={course.img} alt={course.title} />
      </div>
      <div className="card-label">{course.title}</div>
        {!purchased && ( 
          <div className="lock-overlay"
              onClick={(e) => {e.stopPropagation();  navigate("/upgrade");}}>
              <span className="lock-icon">🔒</span>
          </div>
        )}
    </div>
  );
}


function CourseDetails({ courseSlug, coursesData, currentUser, userCourses }) {
  const [lastLecture, setLastLecture] = useState(null);
  const [courseProgress, setCourseProgress] = useState(null);
  const [showPackages, setShowPackages] = useState(false);

  const course = coursesData.find(c => c.slug === courseSlug);
  const userCourse = userCourses.get(courseSlug);
  const courseLevel = userCourse?.level || 0;
  const t = useTranslation();
  const navigate = useNavigate();
  const handleGoToCourse = (slug) => { console.log("CLICKED:", slug); navigate(`/course/${slug}/content`);};
  const [activeCourse, setActiveCourse] = useState(null);

  useEffect(() => { 
    getCourseProgress(courseSlug)
    .then(({ lastLesson, courseProgress }) => {
      setLastLecture(lastLesson);
      setCourseProgress(courseProgress);
    })
    .catch(() => {
      setLastLecture(null);
      setCourseProgress(null);
    });
    }, [courseSlug]);

  return (
    <div>
      <div className="course-details">
        <div className={`course-header clickable course-${course.slug} ${activeCourse === course.slug ? "active-course" : ""}`}
          onClick={() => {
            setActiveCourse(course.slug);   
            handleGoToCourse(course.slug);  
          }}
        >
          {course?.title}
        </div>

        <div className="course-content">
          <div className="course-image clickable"
            onClick={() => handleGoToCourse(course?.slug)}>
            <img src={course?.img} alt={course?.title} />
             <div className="image-overlay">
                <span>To the course page</span>
             </div>
          </div>
          <div className="course-info">
            <p>{t("lastLecture")}</p>
            <span> {lastLecture?.title || t("notStarted")} </span>
            {lastLecture?.lastVisitedAt && (
              <small>
                Last visited: {" "}
                {new Date(lastLecture.lastVisitedAt).toLocaleString()}
              </small>
            )}

            <div className="course-progress-box">
              <p>Progress</p>
              <div className="progress-bar">
                <div className="progress-fill" style={{ width: `${courseProgress?.progressPercent || 0}%` }} />
              </div>
              <small>
                {courseProgress?.totalCompleted || 0} completed /{" "}
                {courseProgress?.totalVisited || 0 } visited
              </small>
            </div>
          </div>

         <div className="top-buttons-wrapper">
            <div className="packages-btn-wrapper">
              <button className="package-btn"
                onClick={() => setShowPackages(prev => !prev)}
              >
                <span>{t("yourPackages")}</span>
                <img src={PackagesIcon} alt="packages" className="package-icon"/>
              </button>
            </div>
            <div className="packages-btn-wrapper">
              <button className="package-btn"
                onClick={() => navigate(`/course/${courseSlug}/history`)}
              >
                <span>{t("myHistory")}</span>
                <img src={arrow} alt="history" className="history-icon"/>
              </button>
            </div>
          </div>
        </div>
      </div>

      {showPackages && (
        <div className="packages-section">
          <Packages courseSlug={courseSlug} user={{...currentUser, subscriptionLevel: courseLevel}} />
        </div>
      )}
    </div>

  );
}